import React from 'react';

export type CollaborationContext = {
	goalWorkspace: string | null;
	projectWorkspace: string | null;
	rovoWorkspace: string | null;
	contextId?: string | null;
	orgCloudIds: string[] | null;
	numWorkspaces?: number;
	collabContextScoping?: {
		collabContextCloudIds?: string[];
		isMultiSite?: boolean;
		collabContextSiteAris?: string[];
		hasMultipleUnits?: boolean;
	} | null;
};

export const CollabContext = React.createContext<CollaborationContext | null>(null);

export const useCollabContext = () => {
	return React.useContext(CollabContext);
};

export const useRovoWorkspace = () => {
	const context = useCollabContext();
	return context?.rovoWorkspace;
};

export const useGoalWorkspace = () => {
	const context = useCollabContext();
	return context?.goalWorkspace ?? null;
};

export const useProjectWorkspace = () => {
	const context = useCollabContext();
	return context?.projectWorkspace ?? null;
};

export const useContextId = () => {
	const context = useCollabContext();
	return context?.contextId ?? null;
};

export const useCollabContextCloudIds = () => {
	const context = useCollabContext();

	return context?.collabContextScoping?.collabContextCloudIds ?? context?.orgCloudIds ?? [];
};
